/**
 * POS Billing Screen (6.6.1 / 6.16.7)
 * Renders the exact POS terminal prototype via PosTerminalEmbed (see that file for details).
 */
import React from 'react';
import PosTerminalEmbed from './PosTerminalEmbed';

const POSBillingScreen = ({ isPosMaximized, setIsPosMaximized }) => (
  <PosTerminalEmbed isPosMaximized={isPosMaximized} setIsPosMaximized={setIsPosMaximized} />
);

export default POSBillingScreen;
